import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  MailAddressValidationModel, PhoneNumberValidationModel,
  IBANValidationModel, VerifyIBANModel, EFTBankListModel, VKNValidationModel, MoneyModel
} from '../models/shared.model';
import 'rxjs/add/operator/delay';
import { ValidationModel } from '../models/validaton.model';
import { SiriusDataService, SiriusServiceBase } from '@ibtech/sirius-angular-service';

@Injectable()
export class ValidationService extends SiriusServiceBase {
    formToValidate: FormGroup;
    checkDirty: boolean = false;
    control: any;
    public signUpForm: FormGroup;
    formValidationModel: ValidationModel[];

    public dataServiceInstance: SiriusDataService;

    public formErrors = {
        'username': '',
        'telephoneNumber': '',
        'email': '',
        'location': ''
    };

    constructor(private dataService: SiriusDataService) {
      super();
    }

    formatMoney(dataService: SiriusDataService, model: MoneyModel) {
        var promise = dataService.post<MoneyModel>("FormatMoney", model);
        return promise;
    }

    validateMail(mailAdres: string) {
        var emailModel = new MailAddressValidationModel();
        emailModel.MailAddress = mailAdres;
        var promise = this.dataService.post<MailAddressValidationModel>("ValidateEmail", emailModel);
        return promise;
    }

    validatePhonenumber(phonenumber: string) {
        var phoneModel = new PhoneNumberValidationModel();
        phoneModel.PhoneNumber = phonenumber;
        var promise = this.dataService.post<PhoneNumberValidationModel>("ValidatePhonenumber", phoneModel);
        return promise;
    } 

    validateIBAN(iban: string) {
        var ibanModel = new IBANValidationModel();
        ibanModel.IBAN = iban;
        var promise = this.dataService.post<IBANValidationModel>("ValidateIBAN", ibanModel);
        return promise;
  }

  validateIBANCorp(iban: string, vkn: string) {
    var ibanModel = new IBANValidationModel();
    ibanModel.IBAN = iban;
    ibanModel.UserType = "T";
    ibanModel.Vkn = vkn;
    var promise = this.dataService.post<IBANValidationModel>("ValidateIBAN", ibanModel);
    return promise;
  }

    validateVKN(vkn: string) {
        var vknModel = new VKNValidationModel();
        vknModel.VKN = vkn;
        var promise = this.dataService.post<VKNValidationModel>("ValidateVKN", vknModel);
        return promise;
    }

    verifyIBAN(iban: string, title: string, userType: string) {
        var ibanModel = new VerifyIBANModel();
        ibanModel.IBAN = iban;
        ibanModel.UserType = userType;
        ibanModel.Title = title;
        var promise = this.dataService.post<VerifyIBANModel>("VerifyIBAN", ibanModel);
        return promise;
    }

    getEftBankList() {
        var eftBankListModel = new EFTBankListModel();
        var promise = this.dataService.post<EFTBankListModel>("GetEFTBankList", eftBankListModel);
        return promise;
    }

    getFormError() {
        return this.formValidationModel;
    }

}
